// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { RedirectRepresentation } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useRedirectResource () {

    /**
     * Get any redirects for the URL being visited
     * @param url (optional) The URL being visited
     * @param culture (optional) The culture to use
     * @return Any redirects to take place
     */
    function getForUrl(
        url?: MaybeRef<string | undefined>,
        culture?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<RedirectRepresentation> {
        const computedUrl = computed( () => {
          let url_ = "/api/redirects/url?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        const cultureUnref = unref( culture );
        if (cultureUnref === null)
            throw new Error("The parameter 'culture' cannot be null.");
        else if (cultureUnref !== undefined)
            url_ += "culture=" + encodeURIComponent("" + cultureUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<RedirectRepresentation> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<RedirectRepresentation>( computedUrl, options_ );
    }

    return {
        getForUrl,
    }
}


export function $redirectResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Get any redirects for the URL being visited
     * @param url (optional) The URL being visited
     * @param culture (optional) The culture to use
     * @return Any redirects to take place
     */
    function getForUrl(
        url?: string | undefined,
        culture?: string | undefined
    ) {
        let url_ = "/api/redirects/url?";

        const urlUnref = unref( url );
        if (urlUnref === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (urlUnref !== undefined)
            url_ += "url=" + encodeURIComponent("" + urlUnref) + "&";
        const cultureUnref = unref( culture );
        if (cultureUnref === null)
            throw new Error("The parameter 'culture' cannot be null.");
        else if (cultureUnref !== undefined)
            url_ += "culture=" + encodeURIComponent("" + cultureUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<RedirectRepresentation>( url_, options_, dependencies_ );
    }

    return {
        getForUrl,
    }
}